import axios from 'src/utils/axiosHelper';
import authService from 'src/services/authService';

const helperAxios = (url, method, body, params, responseType) => {
  let helperUrl = url;
  let helperMethod = method;
  let helperbody = body;
  let helperParams = params;
  let helperResponseType = responseType;
  return new Promise((resolve, reject) => {
    axios({
      url,
      method,
      data: body,
      params,
      responseType
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        if (error && error.response && error.response.status === 401) {
          authService.setSession(null);
          axios({
            method: 'post',
            url: 'api/auth/validateRememberMe'
          })
            .then(response => {
              if (response.data && response.data.token) {
                authService.setSession(response.data.token);
                axios({
                  url: helperUrl,
                  method: helperMethod,
                  data: helperbody,
                  params: helperParams,
                  responseType: helperResponseType
                })
                  .then(response => {
                    resolve(response);
                  })
                  .catch(nestedError => {
                    reject(nestedError);
                  });
              } else {
                authService.setSession(null);
                window.location.href = '/';
              }
            })
            .catch(err => {
              window.location.href = '/';
            });
        } else {
          reject(error);
        }
      });
  });
};

export default helperAxios;
